import type { ReactNode } from 'react';

export type Tone = 'ok' | 'warn' | 'crit' | 'info' | 'neutral' | 'accent';

export function Pill({
  tone = 'neutral',
  dot,
  live,
  icon,
  children,
  title,
}: {
  tone?: Tone;
  dot?: boolean;
  /** A slow pulse on the dot, for "live" states. */
  live?: boolean;
  icon?: ReactNode;
  children: ReactNode;
  title?: string;
}) {
  return (
    <span className={`ui-pill ui-pill--${tone}`} title={title}>
      {dot && <span className={`ui-pill__dot${live ? ' ui-pill__dot--live' : ''}`} aria-hidden />}
      {icon}
      {children}
    </span>
  );
}
